<template>
  <profile-card title="Skills">
    <div class="tw-p-5">
      <div>
        <div class="tw-font-bold tw-mb-2 tw-text-2xl">Add Skills:</div>
        <input ref="search" v-on:keydown.enter.prevent="select(search)" v-model="search" type="text" class="tw-rounded tw-p-4 tw-border tw-w-full" placeholder="Type Some Skills..">
        <div class="tw-p-2">
          <button v-for="skill in filteredSkills" :key="skill.id" v-on:click.prevent="select(skill.title)"
            class="cursor:tw-bg-light-5 tw-inline-block tw-m-2 tw-rounded tw-bg-light-3 tw-py-2 tw-px-3">{{skill.title}}
          </button>
          <button v-on:click.prevent="select(search)" v-if="filteredSkills.length === 0"
            class="cursor:tw-bg-light-5 tw-inline-block tw-m-2 tw-rounded tw-bg-light-3 tw-py-2 tw-px-3">{{search}}
          </button>
        </div>
      </div>
      <div class="tw-font-bold tw-mb-2 tw-mt-8 tw-text-2xl">Your Skills:</div>
      <div class="tw-p-6 tw-text-center tw-text-2xl tw-text-dark" v-if="userSkills.length === 0"> No Skills Yet</div>
      <div class="tw-p-2 tw-pt-0 tw-grid tw-divide-y tw-divide-light-4">
        <div v-for="skill in userSkills" :key="skill.id" class="tw-flex tw-items-center tw-py-4 tw-px-3">
          <div class="tw-w-1/6">{{skill.skill.title}}</div>
          <div class="tw-text-center" style="width:10%">{{skill.grade}}%</div>
          <div class="tw-flex-grow tw-relative tw-h-2 tw-bg-light-6 tw-mx-8 tw-cursor-pointer" v-on:click="update($event,skill.skill.title)">
            <div class="tw-h-2 tw-bg-primary" :style="{width : skill.grade + '%'}"></div>
          </div>
          <button class="tw-ml-1 tw-flex flex-center cursor:tw-text-red" v-on:click.prevent="remove(skill.skill)">
            <i class="bx bx-x tw-text-3xl"></i>
          </button>
        </div>
      </div>
      <!--<button class="tw-rounded tw-bg-secondary tw-px-6 tw-py-3 tw-font-bold tw-text-2xl tw-text-light tw-mx-8 tw-my-5">Save</button>-->
    </div>
  </profile-card>
</template>

<script>
  import _ from "lodash";

  export default {
    props: {
      initialSkills: {},
      initialUserSkills: {},
    },
    data: v => ({
      search: '',
      skills: v.initialSkills,
      userSkills: v.initialUserSkills,
    }),
    computed: {
      filteredSkills() {
        return this.skills
          .filter(skill => skill.title.toLowerCase().includes(this.search.toLowerCase()))
          .filter(skill => this.userSkills.find(userSkill => userSkill.skill.id === skill.id) === undefined)
          .slice(0, 20)
      }
    },
    methods: {
      update(event, title) {
        let grade = Math.round(event.offsetX / event.target.scrollWidth * 100)
        this.select(title, grade)
      },
      select(title, grade = 50) {
        this.search = ''
        this.$refs.search.focus()
        axios.post("/api/v1/skill?api_token=" + window.api_token, {title, grade})
          .then(resp => {
            let exists = this.userSkills.find(userSkill => userSkill.skill.title.toUpperCase() === title.toUpperCase())
            if (exists) {
              exists.grade = grade
            } else {
              this.userSkills.push(resp.data.resource)
            }
            if (this.skills.filter(skill => skill.title === title).length === 0) {
              this.skills.push(resp.data.resource.skill)
            }
          })
          .catch(err => {
            if (err.response && err.response.status === 422) {
              _.forEach(_.filter(err.response.data.errors), errors => {
                Vue.$toast.error(errors[0]);
              })
            }
          })
      },
      remove(skill) {
        axios.delete(`/api/v1/skill/${skill.id}?api_token=${window.api_token}`, {title: skill})
          .then(resp => {
            this.userSkills = this.userSkills.filter(userSkill => userSkill.skill.id !== skill.id)
          })
          .catch(err => {
            if (err.response && err.response.status === 422) {
              _.forEach(err.response.data.errors, errors => {
                Vue.$toast.error(errors[0]);
              })
            }
          })
      }
    },
  }
</script>
